import { createFileRoute } from "@tanstack/react-router";
import GlansBumpsGuide from "@/pages/GlansBumpsGuide";

export const Route = createFileRoute("/guias/bolhas-na-cabeca-do-penis")({
  component: GlansBumpsGuide,
});